import React from "react";
import { Outlet } from "react-router-dom";

const ContactUsRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default ContactUsRoot;
